class HttpCacheFactory {
    constructor($cacheFactory) {
        this.$cacheFactory = $cacheFactory;
    }

    createHttpCache(name) {
        return this.$cacheFactory(name);
    }
}

HttpCacheFactory.$inject = ['$cacheFactory'];

export default HttpCacheFactory;